module.exports = __webpack_public_path__ + "static/media/dz.b37c4fcf.svg";